var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateCallerId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m24.68 27.9-1.295 1.295c-.507.507-1.227.733-2.108.733-2.88 0-7.51-2.56-11.739-6.75l-.053-.053-.053-.053c-5.47-5.523-8.164-11.7-6.017-13.847l1.28-1.294s.014 0 .028-.027a1.809 1.809 0 0 1 2.508.027l2.654 2.654a1.78 1.78 0 0 1 0 2.535l-1.947 1.948c-.828.827.667 3.628 3.321 6.283 2.655 2.655 5.456 4.135 6.283 3.322l1.107-1.108.84-.84a1.764 1.764 0 0 1 2.522 0l2.668 2.654a1.787 1.787 0 0 1 0 2.522z",
    fill: "url(#fevjt361xa)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24.372 28.206-.987.987c-.507.507-1.227.734-2.108.734-2.88 0-7.51-2.561-11.739-6.75l-.053-.053-.053-.054c-5.47-5.522-8.164-11.699-6.017-13.847l.987-.987c-2.147 2.148.547 8.325 6.017 13.847.013.014.04.027.053.054l.053.053c4.23 4.189 8.858 6.75 11.74 6.75.88 0 1.6-.227 2.107-.734z",
    fill: "#FFFDF9",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.777 26.793-2.402 2.401c-.506.507-1.227.734-2.107.734-2.882 0-7.51-2.561-11.74-6.75l-.053-.053-.053-.054c-5.47-5.523-8.164-11.7-6.017-13.847l2.388-2.401a1.804 1.804 0 0 1 2.535 0l2.655 2.655a1.78 1.78 0 0 1 0 2.534L9.035 13.96c-.827.827.667 3.628 3.322 6.283 2.654 2.655 5.456 4.135 6.283 3.322l1.947-1.948a1.764 1.764 0 0 1 2.522 0l2.668 2.655a1.788 1.788 0 0 1 0 2.52z",
    stroke: "url(#mhumx6wx3b)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.908 13.092a2 2 0 0 1 2-2h.939c.71 0 1.334.1 1.874.302a3.512 3.512 0 0 1 1.367.847c.37.37.649.822.834 1.354.186.524.279 1.117.279 1.778 0 .677-.097 1.286-.29 1.826a3.634 3.634 0 0 1-.835 1.367c-.363.37-.814.657-1.355.859-.54.201-1.165.302-1.874.302h-.94a2 2 0 0 1-2-2v-4.635zm1.766 4.3c0 .508.411.92.919.92.483 0 .907-.069 1.27-.206.363-.137.657-.334.883-.592a2.46 2.46 0 0 0 .52-.92c.112-.354.169-.753.169-1.197a3.9 3.9 0 0 0-.17-1.185 2.35 2.35 0 0 0-.52-.907 2.162 2.162 0 0 0-.882-.593c-.363-.137-.787-.205-1.27-.205a.92.92 0 0 0-.92.919v3.967z",
    fill: "url(#zc8723skrc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.354 11.975a.883.883 0 1 1 1.766 0v6.87a.883.883 0 0 1-1.766 0v-6.87z",
    fill: "url(#sodo71sn5d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fevjt361xa",
    x1: 19.389,
    y1: 41.991,
    x2: -3.567,
    y2: 32.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mhumx6wx3b",
    x1: 20.201,
    y1: 42.584,
    x2: -3.885,
    y2: 33.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zc8723skrc",
    x1: 22.402,
    y1: 24.353,
    x2: 12.135,
    y2: 19.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sodo71sn5d",
    x1: 22.402,
    y1: 24.353,
    x2: 12.135,
    y2: 19.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateCallerId);
export default __webpack_public_path__ + "static/media/corporateCallerID.79e3110f2594a3e2ab1d12a517b051b2.svg";
export { ForwardRef as ReactComponent };